import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { recursosHumanosModuleName } from "../../shared/data.service";
import { pessoasModuleName, pessoasStorage } from "../shared/data.service";
import { Pessoa } from "../shared/pessoa.model";
import { editRoute, newRouteFemale } from "../../../shared/services/data.service";
import { PessoaNavigationService } from "../shared/pessoa-navigation.service";
import { PessoaApiService } from "../shared/pessoa-api.service";
import { Funcionario } from "../../funcionarios/funcionario.model";
import { FuncionarioApiService } from "../../funcionarios/funcionario-api.service";
import { PhoneValidator } from "../../../shared/validators/phone.validation";
import { EmailValidator } from "../../../shared/validators/email.validation";
import { UtilService } from "../../../shared/services/util.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { PessoaService } from "../shared/pessoa.service";
import { CpfValidator } from "../../../shared/validators/cpf.validation";
import {AttService} from "../../../shared/services/att.service";

@Component({
    template: require('./pessoa-form.component.html'),
    styles: [require('./pessoa-form.component.css')]
})
export class PessoaFormComponent implements OnInit {
    recursosHumanosModule: any = recursosHumanosModuleName;
    pessoasModule: any = pessoasModuleName;
    formObject: Pessoa = new Pessoa();
    funcionarioObject: Funcionario = new Funcionario();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    isFuncionario: boolean = false;
    imageUrl: string = '';

    form: FormGroup;
    nome = new FormControl('', Validators.required);
    ativo = new FormControl('');
    email = new FormControl('', Validators.compose([EmailValidator.emailFormat]));
    rg = new FormControl('');
    rgOrgaoExpedidor = new FormControl('');
    telefone = new FormControl('', Validators.compose([PhoneValidator.phoneFormat]));
    funcionario = new FormControl('');
    cpf = new FormControl('', Validators.compose([CpfValidator.cpfFormat]));

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responsePessoa: any;
    private imageToSave: any = {};

    constructor(
        private _route: ActivatedRoute,
        private _pessoaNavigationService: PessoaNavigationService,
        private _pessoaApiService: PessoaApiService,
        private _funcionarioApiService: FuncionarioApiService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _pessoaService: PessoaService,
        private _attService: AttService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            email: this.email,
            nome: this.nome,
            rg: this.rg,
            rgOrgaoExpedidor: this.rgOrgaoExpedidor,
            telefone: this.telefone,
            funcionario: this.funcionario,
            cpf: this.cpf
        });
    }

    ngOnInit() {
        this.setImagePattern();
        let id = +this._route.snapshot.params['id'];

        if (id) {
            this.actionTitle = editRoute;
            this.getObject(id);
            this.getImage(id);
        } else {
            this.actionTitle = newRouteFemale;
            this.isNewAutoComplete();
        }
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    clickRemoverImagem() {
        var onDelete = (function() {
            this.onDeleteFile();
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    changeFile(e: any) {
        let target = e.target;

        let isValid = this._attService.isValidAttachment(target, true, false);
        if (isValid) {
            this._attService.loadFile(target.files[0], this.responseSuccessS3File);
        }
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            let object:Pessoa = this.formObject;

            if (object.telefone) {
                object.telefone = this._utilService.removeSpecialCharacter(object.telefone);
            }

            if (object.cpf) {
                object.cpf = this._utilService.removeSpecialCharacter(object.cpf);
            }

            if (object.id) {
                this.onEditPessoa(object);
            } else {
                this.onAddPessoa(object);
            }
        }
    }

    private onAddPessoa(object: Pessoa) {
        var onDone = (function (Response: any) {
            if (!Response.error)  {
                this.responsePessoa = Response;

                if (this.imageToSave.ativo) {
                    this.imageToSave.descricao = Response.nome;
                    this.imageToSave.pessoaId = Response.id;
                    this.onSaveFile();
                }

                if (this.isFuncionario) {
                    this.onAddFuncionario(Response.id);
                } else {
                    this.toLeaveHere();
                }

                this._utilService.swalMessageAddSuccess();
            } else {
                this.btnSaveDisabled = false;
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        this._pessoaApiService.onPost(object, onDone);
    }

    private onEditPessoa(object: Pessoa) {
        var onDone = (function (Response: any) {
            if (!Response.error)  {
                if (this.funcionarioObject && this.funcionarioObject.id) {
                    let object:Funcionario = this.funcionarioObject;
                    object.ativo = this.isFuncionario;
                    this.onEditFuncionario(object);
                } else if (this.isFuncionario) {
                    //se a pessoa nao era um funcionario e foi editado adicionado o funcionario
                    this.onAddFuncionario(this.formObject.id);
                } else {
                    this.goToList();
                }
                this._utilService.swalMessageEditSuccess();
            } else {
                this.btnSaveDisabled = false;
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        this._pessoaApiService.onPut(object, onDone);
    }

    private onAddFuncionario(pessoaId: number) {
        var object: Funcionario = new Funcionario();
        object.pessoaId = pessoaId;

        this._funcionarioApiService.onPost(object, this.onDoneFuncionario);
    }

    private onEditFuncionario(object: Funcionario) {
        this._funcionarioApiService.onPut(object, this.onDoneFuncionario);
    }

    private onDoneFuncionario = (function(Response: any) {
        var funcionarioObject: any = Response;
        funcionarioObject.pessoa = this.responsePessoa;
        this.responsePessoa = funcionarioObject;

        this.btnSaveDisabled = false;
        this.toLeaveHere();
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.getFuncionario(Response.id);
            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma pessoa encontrada com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._pessoaApiService.onGetById(id, onDone);
    }

    private getImage(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                if (Response.length) {
                    this.imageUrl = Response[0].url;
                    this.imageToSave = Response[0];
                }
            }
        }.bind(this));

        this._pessoaApiService.onGetByPessoa(id, onDone);
    }

    private getFuncionario(personId: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.funcionarioObject = Response[0];
                if (this.funcionarioObject) {
                    if (this.funcionarioObject.ativo) {
                        this.isFuncionario = true;
                    }
                }
            }
        }.bind(this));

        this._funcionarioApiService.onGetByPerson(personId, onDone);
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(pessoasStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.nome = newAutoComplete.nome;
            this.isFuncionario = newAutoComplete.isFuncionario;
        }
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._pessoaService.returnToOtherForm(this.otherForm, this.responsePessoa);
        } else {
            this.goToList();
        }
    }

    private goToList() {
        this._pessoaNavigationService.goToList();
    }

    private responseSuccessS3File = (function(response: any) {
        let description = this.formObject.nome;

        let newAtt: any = {
            descricao: description,
            url: response.url,
            formato: response.fileExtension,
            data: new Date(),
            ativo: true,
            pessoaId : this.formObject.id
        };

        if (this.imageToSave.id) {
            newAtt.id = this.imageToSave.id;
        }

        this.imageUrl = response.url;
        this.imageToSave = newAtt;
        if (this.formObject.id) {
            this.onSaveFile();
        }
    }.bind(this));

    private onSaveFile() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                if (this.formObject.id) {
                    this._utilService.swalMessageAddSuccess();
                }
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        if (this.imageToSave.id) {
            this._pessoaApiService.onPutImage(this.imageToSave, onDone);
        } else {
            this._pessoaApiService.onPostImage(this.imageToSave, onDone);
        }
    }

    private onDeleteFile() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.setImagePattern();
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        if (this.imageToSave.id) {
            this._pessoaApiService.onDeleteImage(this.imageToSave.id, onDone);
        } else {
            this.imageToSave = {};
            this.setImagePattern();
            this._utilService.swalMessageDeleteSuccess();;
        }
    }

    private setImagePattern() {
        this.imageUrl = '';
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoas/pessoa-form/pessoa-form.component.ts
 **/